import React, { Component } from "react";
import { Outlet } from "react-router-dom";
import "./index.scss";
// 封装组件
class Engineservices extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  UNSAFE_componentDidUpdate() {}
  render() {
    return (
      <div className="Engine">
        <Outlet />
      </div>
    );
  }
}
export default Engineservices;
